import {BaseContainerModel} from '../base-container.model';
import {bl_mrp_process_template_bom_RowClass} from '../../dbschema';

export class MrpProcessTemplateBOMContainerModel extends BaseContainerModel {
    bl_mrp_process_template_bom: bl_mrp_process_template_bom_RowClass = new bl_mrp_process_template_bom_RowClass();
}
